// https://stackoverflow.com/a/52913382/3344309
export class UnreachableCaseError extends Error {
  constructor(value: never, message='') {
    super(`Unreachable case: ${message} ${JSON.stringify(value)}`);
  }
}